package com.kinoshazam.uiKit.button

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.ButtonDefaults
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.BoldMedium


data class UiKitButtonState(
    val title: TextLabelState? = null,
    val icon: Painter? = null,
    val gap: Dp? = null,
    val backgroundColor: Color? = null,
    val contentState: ButtonContentState = ButtonContentState.ENABLED,
    val iconColor: Color? = null,
    val defaults: UiKitButtonDefaults = UiKitButtonDefaults(),
    val shape: Shape = RoundedCornerShape(6.dp),
) {

    constructor(
        title: String? = null,
        titleColor: Color? = null,
        icon: Painter? = null,
        gap: Dp? = null,
        backgroundColor: Color? = null,
        contentState: ButtonContentState = ButtonContentState.ENABLED,
        iconColor: Color? = null,
        defaults: UiKitButtonDefaults = UiKitButtonDefaults(),
        shape: Shape = RoundedCornerShape(6.dp),
    ) : this(
        title = TextLabelState(
            text = title.orEmpty(),
            textStyle = defaults.textStyle,
            color = titleColor ?: Color.Black,
        ),
        icon = icon,
        gap = gap,
        backgroundColor = backgroundColor,
        contentState = contentState,
        iconColor = iconColor,
        defaults = defaults,
        shape = shape,
    )
}

data class UiKitButtonDefaults(
    val contentPadding: PaddingValues = ButtonDefaults.ContentPadding,
    val textStyle: TextStyle = BoldMedium,
)

enum class ButtonContentState(
    val isEnabled: Boolean,
) {
    ENABLED(true),
    LOADING(true),
    DISABLED(false),
}
